"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const containerCss = core_1.css `
  border-radius: 10px;
  padding: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  background-color: ${design_system_1.Colors.white};
  border: 1px solid ${design_system_1.Colors.grey200};
`;
const iconContainerCss = core_1.css `
  margin-right: 15px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  border: 1px solid ${design_system_1.Colors.grey200};
`;
const contentContainerCss = core_1.css `
  display: flex;
  flex-direction: column;
  text-align: left;
`;
function InactiveHeader({ stepNumber, title, description, }) {
    return (common_utils_1.isolateComponent("div", { css: containerCss },
        common_utils_1.isolateComponent("div", { css: iconContainerCss },
            common_utils_1.isolateComponent(common_components_1.Icon, { color: "grey200", name: "bolt", size: 32 })),
        common_utils_1.isolateComponent("div", { css: contentContainerCss },
            common_utils_1.isolateComponent(design_system_1.Text, { color: "black", type: "subtitle800" },
                stepNumber,
                ". ",
                title),
            common_utils_1.isolateComponent(design_system_1.Text, { color: "grey700", type: "altText900" }, description))));
}
exports.default = InactiveHeader;
